import type { Locale } from '@embedpdf/react/i18n';

/**
 * English pack. Strings belong to the PRODUCT, not the plugins — the
 * `commands.*` namespace mirrors the v2 snippet packs so translations carry
 * over; `demo.*` is this example's own chrome.
 */
export const en: Locale = {
  code: 'en',
  name: 'English',
  translations: {
    commands: {
      zoom: {
        in: 'Zoom In',
        out: 'Zoom Out',
        fitPage: 'Fit to Page',
        fitWidth: 'Fit to Width',
        automatic: 'Automatic',
        menu: 'Zoom',
        level: 'Zoom Level',
        p50: '50%',
        p100: '100%',
        p150: '150%',
        p200: '200%',
        p400: '400%',
      },
      pan: 'Pan',
      pointer: 'Pointer',
      sidebar: 'Sidebar',
      search: 'Search',
      comment: 'Comment',
      style: 'Style',
      menu: 'Menu',
      viewControls: 'View Controls',
      download: 'Download',
      print: 'Print',
      fullscreen: 'Full Screen',
      spread: { group: 'Page Layout', none: 'Single Page', odd: 'Two Page', even: 'Cover Page' },
      scroll: { group: 'Scrolling', vertical: 'Vertical', horizontal: 'Horizontal' },
      rotate: {
        group: 'Rotate',
        clockwise: 'Rotate Clockwise',
        counterclockwise: 'Rotate Counter-Clockwise',
      },
      mode: {
        group: 'Mode',
        view: 'View',
        annotate: 'Annotate',
        shapes: 'Shapes',
        insert: 'Insert',
        form: 'Form',
        redact: 'Redact',
      },
      annotate: {
        highlight: 'Highlight',
        strikeout: 'Strikeout',
        underline: 'Underline',
        squiggly: 'Squiggly',
        ink: 'Draw',
        inkHighlight: 'Ink Highlighter',
        text: 'Text',
        insertText: 'Insert Text',
        replaceText: 'Replace Text',
        callout: 'Callout',
        note: 'Comment',
        link: 'Link',
        gotoLink: 'Go to link',
        removeLink: 'Remove link',
        delete: 'Delete',
        group: 'Group',
        ungroup: 'Ungroup',
        strip: 'Annotation actions',
      },
      shapes: {
        rectangle: 'Rectangle',
        circle: 'Circle',
        line: 'Line',
        arrow: 'Arrow',
        polygon: 'Polygon',
        polyline: 'Polyline',
      },
      insert: {
        stamp: 'Rubber Stamp',
        attachment: 'Attach File',
        signature: 'Signature',
        image: 'Image',
      },
      form: {
        textfield: 'Text Field',
        checkbox: 'Checkbox',
        radio: 'Radio Button',
        select: 'Dropdown',
        listbox: 'List Box',
      },
      redact: {
        mark: 'Mark for Redaction',
        applyAll: 'Apply Redactions',
        clearAll: 'Clear Marks',
        panel: 'Redactions',
      },
      undo: 'Undo',
      redo: 'Redo',
    },
    passwordPrompt: {
      title: 'Password required',
      required: 'This document is password protected. Enter the password to open it.',
      incorrect: 'The password was incorrect. Please try again.',
      incorrectWarning: 'Incorrect password',
      label: 'Password',
      placeholder: 'Enter password',
      cancel: 'Cancel',
      open: 'Open',
      opening: 'Opening…',
    },
    documentError: {
      title: 'Couldn’t open document',
      unknown: 'The document could not be opened.',
      close: 'Close document',
    },
    demo: {
      starting: 'Starting viewer…',
      opening: 'Opening document…',
      more: 'More',
      thumbnails: 'Thumbnails',
      outline: 'Outline',
      searchPlaceholder: 'Search document…',
      searchTitle: 'Search',
      searchCaseSensitive: 'Case sensitive',
      searchWholeWord: 'Whole word',
      searchRegex: 'Regular expression',
      searchSearching: 'Searching…',
      searchResults: '{count} results found',
      searchNoResults: 'No results',
      searchPage: 'Page {page}',
      commentsTitle: 'Comments',
      styleTitle: 'Style',
      empty: 'Nothing here yet in this demo panel.',
      page: 'Page {current} of {total}',
      cancel: 'Cancel',
      pageBadge: 'p. {page}',
      redactionTitle: 'Redactions',
      redactionEmpty: 'No pending redactions. Use the Redact tool to mark text or areas.',
      redactionArea: 'Area mark',
      redactionText: 'Text mark',
      redactionRemove: 'Remove mark',
      redactConfirmTitle: 'Apply redactions?',
      redactConfirmBody:
        'Permanently remove the content under {count} redaction marks. This cannot be undone.',
      redactConfirmCollateral: '{count} other annotations will also be removed.',
      redactApply: 'Apply',
      redactApplying: 'Applying…',
      redactLabelTitle: 'Redaction label',
      redactLabelPlaceholder: 'e.g. REDACTED',
      redactLabelRepeat: 'Repeat label across region',
    },
  },
};
